var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse ",
    cx: 10,
    cy: 10.1412,
    rx: 7,
    ry: 7.09871,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 10C20 11.9778 19.4135 13.9112 18.3147 15.5557C17.2159 17.2002 15.6541 18.4819 13.8268 19.2388C11.9996 19.9957 9.98891 20.1937 8.0491 19.8078C6.10929 19.422 4.32746 18.4696 2.92894 17.0711C1.53041 15.6725 0.578004 13.8907 0.192152 11.9509C-0.1937 10.0111 0.00433281 8.00043 0.761209 6.17316C1.51809 4.3459 2.79981 2.78412 4.4443 1.6853C6.08879 0.58649 8.02219 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34783 20 10ZM14.7438 9.0625H10.9375V5.25625C10.9375 5.00761 10.8387 4.76915 10.6629 4.59334C10.4871 4.41752 10.2486 4.31875 10 4.31875C9.75136 4.31875 9.51291 4.41752 9.33709 4.59334C9.16128 4.76915 9.0625 5.00761 9.0625 5.25625V9.0625H5.25625C5.00761 9.0625 4.76916 9.16127 4.59334 9.33709C4.41753 9.5129 4.31875 9.75136 4.31875 10C4.31875 10.2486 4.41753 10.4871 4.59334 10.6629C4.76916 10.8387 5.00761 10.9375 5.25625 10.9375H9.0625V14.7437C9.0625 14.9924 9.16128 15.2308 9.33709 15.4067C9.51291 15.5825 9.75136 15.6812 10 15.6812C10.2486 15.6812 10.4871 15.5825 10.6629 15.4067C10.8387 15.2308 10.9375 14.9924 10.9375 14.7437V10.9375H14.7438C14.9924 10.9375 15.2308 10.8387 15.4067 10.6629C15.5825 10.4871 15.6813 10.2486 15.6813 10C15.6813 9.75136 15.5825 9.5129 15.4067 9.33709C15.2308 9.16127 14.9924 9.0625 14.7438 9.0625Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6302489e1d7c16b4bb6f8a749fbe1789.svg";
export { ForwardRef as ReactComponent };